import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import { withRouter } from "../utils/withRouter.js";
import { login } from "../services/TeacherAPIClient.js";
import { FaEye, FaEyeSlash, FaEnvelope, FaLock } from "react-icons/fa";
import {
  getTeacherAuthErrorMessage,
  validateTeacherToken
} from "../utils/auth";

import "./Login.css";

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.state = {
      username: "",
      password: "",
      error: Boolean(props.router.location.state?.authError),
      errorMessage: props.router.location.state?.authError || "",
      showPassword: false,
      isLoading: false,
    };
  }

  setUsername(username) {
    this.setState({ username: username.toLowerCase(), error: false, errorMessage: "" });
  }

  setPassword(password) {
    this.setState({ password: password, error: false, errorMessage: "" });
  }

  togglePasswordVisibility() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.state.username || !this.state.password) {
      this.setState({
        error: true,
        errorMessage: "Both username and password are required.",
      });
      return;
    }

    this.setState({ isLoading: true });

    login(this.state.username, this.state.password)
      .then((data) => {
        const token = typeof data === "string" ? data : data?.token;
        const validation = validateTeacherToken(token);

        if (!validation.valid) {
          localStorage.removeItem("token");
          this.setState({
            error: true,
            isLoading: false,
            errorMessage: getTeacherAuthErrorMessage(validation.reason),
            password: ""
          });
          return;
        }

        localStorage.setItem("token", token);
        const searchParams = new URLSearchParams(
          this.props.router.location.search
        );
        searchParams.delete("token");
        const cleanSearch = searchParams.toString();

        this.props.router.navigate({
          pathname: "/masterdashboard",
          search: cleanSearch ? `?${cleanSearch}` : ""
        });
      })
      .catch(() => {
        this.setState({
          error: true,
          isLoading: false,
          errorMessage: `Having trouble logging in? Please verify that you are using the correct email address for ALPACA. If the issue persists, contact Cathal at cathal@alpaca-assessment.com for assistance.`,
          password: "",
        });
      });
  }

  render() {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h2 className="login-title">ALPACA Teacher Help Centre</h2>
            <p className="login-subtitle">Please sign in to continue</p>
          </div>

          <Form className="login-form" onSubmit={this.handleSubmit}>
            <Form.Group className="form-group">
              <Form.Label className="form-label">Email Address</Form.Label>
              <InputGroup className="input-group-modern">
                <InputGroup.Text className="input-icon">
                  <FaEnvelope />
                </InputGroup.Text>
                <Form.Control
                  autoFocus
                  type="email"
                  placeholder="Enter your email"
                  value={this.state.username}
                  onChange={(e) => this.setUsername(e.target.value)}
                  className="form-input"
                />
              </InputGroup>
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Label className="form-label">Password</Form.Label>
              <InputGroup className="input-group-modern">
                <InputGroup.Text className="input-icon">
                  <FaLock />
                </InputGroup.Text>
                <Form.Control
                  type={this.state.showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={this.state.password}
                  onChange={(e) => this.setPassword(e.target.value)}
                  className="form-input"
                />
                <InputGroup.Text 
                  onClick={this.togglePasswordVisibility}
                  className="password-toggle"
                >
                  {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>

            <Button
              type="submit"
              className="login-button"
              disabled={!this.validateForm() || this.state.isLoading}
            >
              {this.state.isLoading ? (
                <>
                  <span className="spinner"></span>
                  Signing In...
                </>
              ) : (
                "Sign In"
              )}
            </Button>

            {this.state.errorMessage && (
              <div className="error-message">
                <div className="error-content">
                  {this.state.errorMessage}
                </div>
              </div>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
